import React from 'react';
import {
  Home,
  Briefcase,
  Zap,
  BookOpen,
  Linkedin,
  Mail
} from 'lucide-react';
import './MobileNav.css';

export default function MobileNav({ items }) {
  return (
    <nav className="mobile-nav" role="navigation" aria-label="Mobile navigation">
      {items.map((item, index) => (
        <button
          key={index}
          className={`mobile-nav-item${item.className === 'dock-divider-before' ? ' mobile-nav-divider-before' : ''}`}
          onClick={item.onClick}
          aria-label={item.label}
        >
          <span className="mobile-nav-icon">{item.icon}</span>
          <span className="mobile-nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
